import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { callbackUrl } from '../../api/util';
import { ConsumerLoanTargetPath } from '../../domain/types';
import useSettings from '../../hooks/useSettings';
import useTranslation from '../../hooks/useTranslation';
import { DialogActionStyles, DialogButton, Link, smallScreenSX } from './OngoingApplicationDialog.styles';

type Props = {
    applicationReferenceNumber: string | undefined;
};
const OngoingApplicationDialog = ({ applicationReferenceNumber }: Props) => {
    const [open, setOpen] = useState(false);
    const translate = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const settings = useSettings();

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (applicationReferenceNumber) {
            setOpen(true);
        }
    }, [applicationReferenceNumber]);

    const openExistingApplication = () => {
        const url = callbackUrl(
            ConsumerLoanTargetPath.ongoing,
            settings.languageCode,
            settings.countryCode,
            applicationReferenceNumber!,
        );

        window.location.assign(url);
    };

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                sx={isSmallScreen ? smallScreenSX : undefined}>
                <DialogTitle id="alert-dialog-title">{translate(`page.application.dialog.title`)}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translate(`page.application.dialog.content`)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={DialogActionStyles}>
                    <Button onClick={handleClose} sx={DialogButton}>
                        <Link onClick={openExistingApplication}> {translate(`page.application.dialog.button`)}</Link>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default OngoingApplicationDialog;
